import * as React from 'react';
import * as styles from './styles.css';

import { FormInput, IFormInputProps } from '../FormInput';
import { useDeviceType } from '@cian/ui-kit';

export interface IFormInputsLayoutProps {
  InputProps: IFormInputProps;
  secondInputProps?: IFormInputProps;
  fullwidth?: boolean;
}

export const FormInputsLayout: React.FC<IFormInputsLayoutProps> = props => {
  const { InputProps, secondInputProps, fullwidth } = props;
  const deviceType = useDeviceType();

  return (
    <div className={styles['container']}>
      <div className={fullwidth ? styles['fullwidth'] : styles['input']}>
        <FormInput autoFocus={deviceType === 'desktop'} {...InputProps} />
      </div>
      {secondInputProps && (
        <div className={fullwidth ? styles['fullwidth'] : styles['input']}>
          <FormInput {...secondInputProps} />
        </div>
      )}
    </div>
  );
};

FormInputsLayout.displayName = 'FormInputsLayout';
